export const worklogApprovalKey = (assignationExternalId: string, weekFirstDayIso: string): string =>
  `${assignationExternalId}-${weekFirstDayIso}`;
